import React, { useState } from "react";
import { Tabs, Tab, Paper } from "@material-ui/core";

import ResearchTopicTable from "../../containers/ResearchTopic/ResearchTopicTable";
import ResearchTopicDashboard from "../../containers/ResearchTopic/ResearchTopicDashboard";

// [VinUni] Quản lý đề tài - màn hình chính (Danh sách + Dashboard).
export default function ResearchTopic() {
  const [tab, setTab] = useState(0);
  return (
    <div style={{ padding: 8, minHeight: "calc(100vh - 178px)" }}>
      <Paper style={{ marginBottom: 12 }}>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary">
          <Tab label="Danh sách đề tài" />
          <Tab label="Dashboard" />
        </Tabs>
      </Paper>
      {tab === 0 ? <ResearchTopicTable /> : <ResearchTopicDashboard />}
    </div>
  );
}
